module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-CondensedBlack.6d398940.ttf";